import { api } from "../../services/Api.js";

export function get_album({ commit, state }, payload){
      
    commit('SET_ALBUM',{title:" "}); 

    payload.token=state.appSettings.token
    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    
    return new Promise( (resolve)=>{
      return api
      .post(school,"get_album.php",payload)
      .then( result =>{ 
        commit('SET_ALBUM', result.data);
        resolve();
      });

    });
    

  }